import request from "@/utils/request";

// 入仓号 / 出库单远程查询；outbountNo 为后台约定的参数名。
export function queryOutbound(params) {
  return request({
    url: "/api/mts-api/goods/outbound/detail",
    errorMessages: { 404: "入仓号 / 出库单查询服务不可用，请核对接口地址或部署状态" },
    method: "get",
    params,
  });
}

export function searchWarehouseGoods(warehouseNo, warehouse) {
  return request({
    url: "/api/mts-api/goods/inspection/warehouseGoods",
    method: "get",
    params: { warehouseNo, warehouse },
    skipLoading: true,
    skipErrorMessage: true,
  });
}

// 出库明细：按关键词搜索库存商品。
export function searchStockGoods(keyword, warehouse) {
  return request({
    url: "/api/mts-api/goods/inspection/stockGoods",
    method: "get",
    params: { keyword, warehouse },
    skipLoading: true,
    skipErrorMessage: true,
  });
}

export function listGoods(param) {
  return request({
    url: "/api/mts-api/goods/list",
    method: "get",
    params: param,
  });
}

// 谈判人接取普通用户发布的商品
export function setUserGoods(goods) {
  return request({
    url: "/api/mts-api/goods/setUserGoods",
    method: "post",
    data: goods && typeof goods === "object" ? goods : { id: goods },
  });
}

// 谈判人将已接单的大宗商品整单转化或拆分给指定买家。
export function handlerOrderSplit(data) {
  return request({
    url: "/api/mts-api/goods/handlerOrderSplit",
    method: "post",
    data,
  });
}

// 普通用户上传商品发货凭证
export function userUploadGoods(data) {
  return request({
    url: "/api/mts-api/goods/userUploadGoods",
    method: "post",
    data,
  });
}

// 查询商品关联订单，供谈判人结单时校验
export function getGoodsOrder(goodsId) {
  return request({
    url: "/api/mts-api/goods/getGoodsOrder",
    method: "get",
    params: { goodsId },
  });
}

// 谈判人提交商品结单
export function dispatchBalance(data) {
  return request({
    url: "/api/mts-api/goods/dispatchBalance",
    method: "post",
    data,
  });
}

// 全站搜索页商品查询：只走 Java MTS 服务，不经过 OpenWebUI/AI 助手。
export function searchMallProducts({ keyword, page = 1, pageSize = 100 }) {
  return request({
    url: "/api/mts-api/goods/search",
    method: "get",
    params: {
      keyword,
      page,
      pageSize,
    },
    // 全站搜索属于公开浏览能力。即使旧服务尚未更新白名单，也不能
    // 触发登录弹窗或全局 Unauthorized 提示，由搜索页展示自己的错误状态。
    skipAuthRedirect: true,
    skipErrorMessage: true,
  }).then((res) => {
    if (res && res.code !== undefined && res.code !== 200) {
      throw new Error(res.msg || "商城查询接口异常");
    }
    return res && res.data ? res.data : res;
  });
}

// 货源商品详情
export function getMtsGoodsDetail(goodsCode, orderNum, options = {}) {
  return request({
    skipErrorMessage: Boolean(options.skipErrorMessage),
    url: "/api/mts-api/goods/detail",
    method: "get",
    params: {
      goodsCode,
      orderNum,
    },
  });
}

// 验货
export function yanhuo(data) {
  return request({
    url: "/api/mts-api/mtsGoods/yanhuo",
    method: "post",
    data: data,
  });
}

// 上传验货数据：后台统一按对象数组接收。
export function uploadInspectionData(data, options = {}) {
  return request({
    skipErrorMessage: Boolean(options.skipErrorMessage),
    url: "/api/mts-api/goods/inspection/uploadInspectionData",
    method: "post",
    data: Array.isArray(data) ? data : [data],
  });
}

// 查看验货数据
export function getInspectionData(data, options = {}) {
  return request({
    skipErrorMessage: Boolean(options.skipErrorMessage),
    url: "/api/mts-api/goods/inspection/getInspectionData",
    method: "post",
    data: data,
  });
}

export function deleteInspection(id, options = {}) {
  return request({
    skipErrorMessage: Boolean(options.skipErrorMessage),
    url: `/api/mts-api/goods/inspection/delete/${encodeURIComponent(id)}`,
    method: "delete",
  });
}

// 更新验货状态（确认/驳回）：后台统一按对象数组接收。
export function updateInspectionStatus(data, options = {}) {
  return request({
    skipErrorMessage: Boolean(options.skipErrorMessage),
    url: "/api/mts-api/goods/inspection/updateInspectionStatus",
    method: "post",
    data: Array.isArray(data) ? data : [data],
  });
}

// 独立入口避免误调用尚未更新的旧“整合同驳回”服务。
export function rejectSelectedInspection(data, options = {}) {
  return request({
    skipErrorMessage: Boolean(options.skipErrorMessage),
    url: "/api/mts-api/goods/inspection/rejectSelected",
    method: "post",
    data: Array.isArray(data) ? data : [data],
  });
}

// 查询商品验收状态（供前端页面加载时调用，控制按钮是否禁用）
export function getInspectionStatus(data, options = {}) {
  return request({
    skipErrorMessage: Boolean(options.skipErrorMessage),
    url: "/api/mts-api/goods/inspection/getInspectionStatus",
    method: "get",
    params: data,
  });
}

/**
 * 查询验货相关的订单列表（供验货页面使用）
 * @param {*} params
 * orderNum 订单号
 */
export function getInspectionList(params) {
  return request({
    url: "/api/mts-api/goods/inspection/getInspectionList",
    method: "get",
    params,
  });
}

// // 快速更新验货状态（确认/驳回）
// export function updateInspectionStatus(data) {
//   return request({
//     url: '/api/mts-api/goods/inspection/updateInspectionStatus',
//     method: 'post',
//     data: data,
//   })
// }
//
// //pcj
// // 查询商品验收状态
// export function getInspectionStatus(params) {
//   return request({
//     url: '/api/mts-api/goods/inspection/getInspectionStatus',
//     method: 'get',
//     params
//   })
// }
